import React, { useState } from 'react';
import { Video, BookOpen } from 'lucide-react';
import Sidebar from './Sidebar';
import SymbolToolbar from './SymbolToolbar';
import QuestionCard from './QuestionCard';
import PreviewModal from './PreviewModal';
import ImportModal from './ImportModal';
import HistoryModal from './HistoryModal';
import PanduanModal from './PanduanModal';
import { useQuiz } from '../context/QuizContext';
import { useFocusTracker } from './TrackedField';
import { t } from '../i18n';
import { downloadXML, exportToPDF, exportToDOCX } from '../utils/exporters';
import { toast } from '../hooks/use-toast';

const MainLayout = () => {
  const { quizTitle, setQuizTitle, questions, lang } = useQuiz();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [panduanOpen, setPanduanOpen] = useState(false);

  useFocusTracker();

  const requireQuestions = () => {
    if (!questions.length) {
      toast({ title: lang === 'id' ? 'Belum ada soal' : 'No questions', description: lang === 'id' ? 'Tambahkan minimal satu soal terlebih dahulu.' : 'Please add at least one question first.' });
      return false;
    }
    return true;
  };

  const handleDownloadXml = () => {
    if (!requireQuestions()) return;
    downloadXML(quizTitle, questions);
  };

  const handleExport = async (kind) => {
    if (!requireQuestions()) return;
    try {
      if (kind === 'pdf') exportToPDF(quizTitle, questions);
      if (kind === 'docx') await exportToDOCX(quizTitle, questions);
    } catch (e) {
      toast({ title: 'Export error', description: e.message });
    }
  };

  return (
    <div className="App">
      <div className="mg-shell">
        <Sidebar
          onPreview={() => setPreviewOpen(true)}
          onImport={() => setImportOpen(true)}
          onHistory={() => setHistoryOpen(true)}
          onExport={handleExport}
          onDownloadXml={handleDownloadXml}
        />

        <main className="mg-main">
          <div className="mg-header-row">
            <div className="mg-title">
              <BookOpen size={22} color="#1e4b8a" />
              {t('appTitle', lang)}
            </div>
            <a className="mg-tutorial" href="https://youtu.be/7RpX6iQxU0o" target="_blank" rel="noopener noreferrer">
              <Video size={16} /> {t('videoTutorial', lang)}
            </a>
          </div>

          <SymbolToolbar />

          <div className="mg-panel">
            <label className="mg-label">{t('quizTitle', lang)}</label>
            <input className="mg-input" placeholder={t('quizTitlePh', lang)} value={quizTitle} onChange={e => setQuizTitle(e.target.value)} />
            <div style={{ marginTop: 12 }}>
              <button className="mg-btn info" style={{ width: 'auto', padding: '8px 14px' }} onClick={() => setPanduanOpen(true)}>
                <BookOpen size={16} /> {t('panduan', lang)}
              </button>
            </div>
          </div>

          {questions.length === 0 && (
            <div className="mg-panel" style={{ textAlign: 'center', color: '#6b7280' }}>
              {t('noQuestions', lang)}
            </div>
          )}

          {questions.map((q, i) => (
            <QuestionCard key={q.id} q={q} index={i} />
          ))}

          <footer className="mg-footer">
            © 2026 | <span style={{ color: '#1e4b8a', fontWeight: 700 }}>Tim IT YAPI</span>
          </footer>
        </main>
      </div>

      {previewOpen && <PreviewModal onClose={() => setPreviewOpen(false)} />}
      {importOpen && <ImportModal onClose={() => setImportOpen(false)} />}
      {historyOpen && <HistoryModal onClose={() => setHistoryOpen(false)} />}
      {panduanOpen && <PanduanModal onClose={() => setPanduanOpen(false)} />}
    </div>
  );
};

export default MainLayout;
